export function initialize(appInstance) {
  const config = appInstance.resolveRegistration('config:environment');
  if (!config.eventstream?.name && !config.APP?.name) {
    if (!config.eventstream) {
      config.eventstream = {};
    }
    config.eventstream.name = 'multipass-ui-component';
  }
}
export default {
  before: 'eventstream',
  initialize
};